import React from 'react';
import './success10k.scss';
import triassicParkDoor from '../../../assets/triassic-park-door.jpg';
import triassicParkGate from '../../../assets/triassicParkGate.zip';


const Success10k = () => {
    return (
        <div className='success10k'>
            <h4>¡Enhorabuena!</h4>
            <p className='success-text'>Ahora puedes descargarte el recortable de la puerta de Triassic Park:</p>
            <img src={triassicParkDoor} width={300} alt="door of the thematic park Triassic Park"/>    
            <a className='asButton' href={triassicParkGate} download='TriassicParkGate.zip'>Descargar</a>
        </div>
    );
}

export default Success10k;